// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__cSTI9","description":"PatientConsentPreview_description__23_3Z"};